<template>
  <div id="help-login-detail" class="help">
    <call />
    <!-- header -->
    <top-bar title="ヘルプ" backUrl="/help/login"/>
    <!-- main -->
    <main>
      <footer-app page="top" :loading="loading"></footer-app>
      <section>
        <div class="l-main--bg-border l-main--bg-border--pink">
          <div class="l-main__body">
            <div class="l-check-cart">
              <div class="l-check-cart__head pb-50">
                <div class="l-check-cart__title text-left">アカウント連携</div>
                <div class="help-card mb-16">
                  <div class="l-check-cart__title text-left">アカウント連携方法</div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">1.マイページ画面を表示する</p>
                    <p>サイドメニューより「マイページ」をタップし、マイページ画面を表示します。</p>
                    <img class="border" src="/assets/images/help/help-login-1.png" alt="" />
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">2.アカウント連携するボタンをタップする</p>
                    <p>マイページ画面の「連携する」ボタンをタップします。</p>
                    <img class="border" src="/assets/images/help/login-guide-2.png" alt="" />
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">3.お持ちのアカウントでアカウント連携する</p>
                    <p>アカウント連携画面で、お客さまがお持ちのApple、Google、LINEのアカウントのいずれかで連携してください。</p>
                    <img class="border" src="/assets/images/help/help-login-3.png" alt="" />
                    <p class="sns-login">
                      →Appleでサインインする方法は<router-link to="/help/login/apple" class="snslink">こちら</router-link><br />
                      →Googleでログインする方法は<router-link to="/help/login/google" class="snslink">こちら</router-link><br />
                      →LINEでログインする方法は<router-link to="/help/login/line" class="snslink">こちら</router-link>
                    </p>
                  </div>
                </div>
                <div class="help-card mb-51">
                  <div class="l-check-cart__title text-left">連携解除方法</div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">1.マイページを表示する</p>
                    <p>サイドメニューより「マイページ」をタップし、マイページ画面を表示します。</p>
                    <img class="border" src="/assets/images/help/help-login-4.png" alt="" />
                  </div>
                  <div class="detail-wrap">
                    <p class="l-check-cart__title text-left">2.〇〇で連携中をタップする</p>
                    <p>マイページ画面の「〇〇で連携中」をタップすると連携を解除できます。</p>
                    <img class="border" src="/assets/images/help/guide-login-5.png" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      <button-back />
    </main>
  </div>
</template>

<script>
import "core-js/stable";
import "regenerator-runtime/runtime";
import Vue from "vue";
import { Common } from "../common/common.js";
import { Tenant } from "../plugin/mixin.js";
import TopBar from "../components/TopBar.vue";
import Footer from "../components/Footer.vue";
import ButtonBack from "../components/ButtonBack.vue";

export default Vue.extend({
  name: "HelpLoginDetail",
  components: {
    TopBar,
    FooterApp: Footer,
    ButtonBack,
  },
  mixins: [Tenant],
  data() {
    return {
      loading: false,
    };
  },
  created() {
    this.init();
  },
  mounted() {
    Common.initDom();
  },
  methods: {
    async init() {
      Common.vueInitFunc(this);
      this.loading = false;
    },
  },
});
</script>